<template>
  <div :class="[$style.outerbox, $style.bgColor, (navBarFixed == true) ? $style['navBarWrap'] :'']">
    <div :class="$style.outerbox" :style="[computedWidth, navHeight]">
      <ul :class="$style.navs">
        <router-link v-for="item in navs" v-if="!item.auth" :key="item.name" :to="item.url" :active-class="$style.focus">{{item.name}}</router-link>
      </ul>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      styles: {
        type: Object
      },
      list: {
        type: Array
      },
      sticky: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        currentIdx: 0,
        navs: [],
        navBarFixed: false
      }
    },
    mounted () {
      this.navs = this.list
      if (this.sticky) {
        window.addEventListener('scroll', this.watchScroll)
      }
    },
    destroyed () {
      if (this.sticky) {
        window.removeEventListener('scroll', this.watchScroll)
      }
    },
    computed: {
      computedWidth () {
        return {
          width: this.$vars.theme.width + 'px'
        }
      },
      navHeight () {
        return {
          height: (this.styles.height) ? this.styles.height: '40px',
          lineHeight: (this.styles.height) ? this.styles.height: '40px'
        }
      }
    },
    methods: {
      watchScroll () {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        //  当滚动超过 60 时，实现吸顶效果
        if (scrollTop > 59) {
          this.navBarFixed = true
        } else {
          this.navBarFixed = false
        }
      }
    }
  }
</script>
<style module>
  .outerbox {
    width: 100%;
    composes: outerbox from '../../../assets/css/projcommon.css';
  }
  .navBarWrap {
    position:fixed;
    top: 0px;
    z-index:999;
  }
  .bgColor { background-color: #c0010f; }
  .navs > a {
    width: 120px;
    color: #fff;
    text-align: center;
    display: block;
    float: left;
    cursor: pointer;
  }
  .navs > a:last-child { margin-right: 0; }
  .navs > a.focus { background-color: #e72b12; color: #fff;}
</style>



// WEBPACK FOOTER //
// src/components/hsm/nav/index.vue